import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { wapactPageCount, handleCallNewsApp } from 'ThreeTerminal_utils';
import { SimpleGuideLayer } from 'ThreeTerminal_mobile_dynamic';
import ArticleContent from '../../../../../components/articleContent';

class MainContent extends React.PureComponent {
    static propTypes = {
        imagesInContent: PropTypes.array,
        content: PropTypes.object,
        pluginData: PropTypes.object,
        isBig: PropTypes.bool,
        unfoldType: PropTypes.string,
        base62Id: PropTypes.string,
        pageType: PropTypes.string,
        articleUnfoldLayer: PropTypes.object,
        searchPath: PropTypes.string,
        isHitBlack: PropTypes.bool,
        hasCopyRight: PropTypes.bool,
        textListAd: PropTypes.object,
    };

    state = {
        style: { margin: '0 15px' },
        maskShow: false,
        percent: 0,
        isShowGuideLayer: false,
    };

    mainContent = React.createRef();

    componentDidMount() {
        const clientHeight = this.mainContent.current.clientHeight;

        if (clientHeight > 800 && !this.searchPathNotShowMask()) {
            this.setState({
                style: {
                    position: 'relative',
                    height: '800px',
                    overflow: 'hidden',
                },
                maskShow: true,
                percent: Math.round(((clientHeight - 800) / clientHeight) * 100),
            });
        }
    }

    searchPathNotShowMask() {
        const searchPathList = ['275893-'];
        const { searchPath } = this.props;

        if (!searchPath) {
            return false;
        }

        const filterResult = searchPathList.filter((item) => {
            return searchPath.indexOf(item) !== -1;
        });

        return !!filterResult.length;
    }

    getMore = () => {
        const { unfoldType } = this.props;

        wapactPageCount({
            value: 'load_next',
            method: 'get',
        });

        if (unfoldType === '2' || unfoldType === '3') {
            this.setState({
                isShowGuideLayer: true,
            });
        } else {
            this.setState({
                style: {},
                maskShow: false,
            });
        }
    };

    closeGuideLayer = () => {
        const { unfoldType } = this.props;

        wapactPageCount({
            value: 'cancelentry',
            method: 'get',
        });

        if (unfoldType === '3') {
            this.setState({
                isShowGuideLayer: false,
            });
        } else {
            this.setState({
                style: {},
                maskShow: false,
                isShowGuideLayer: false,
            });
        }
    };

    gotoClientLayer = () => {
        const { base62Id } = this.props;
        const aid = `ucms_${base62Id}`;
        const share = location.href;
        const downloads = {
            download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1451070005296',
            downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8792',
        };

        wapactPageCount({
            value: 'enter',
            method: 'get',
        });

        handleCallNewsApp('', 'doc', aid, share, 0, 0, 'inter_sflahuo02', { noPrefixKind: true }, downloads);
    };

    setCutoffHeight = (value) => {
        this.setState({
            style: {
                ...this.state.style,
                height: `${value}px`,
                overflow: 'hidden',
            },
            maskShow: false,
            isShowGuideLayer: false,
        });
    };

    render() {
        const { style, maskShow, percent, isShowGuideLayer } = this.state;
        const {
            imagesInContent,
            content,
            pluginData,
            isBig,
            pageType,
            unfoldType,
            articleUnfoldLayer,
            hasCopyRight,
            isHitBlack,
            textListAd,
        } = this.props;

        const pageInfo = {
            callAppSurveyConfig: {
                docType: 'doc',
                pid: content._id,
                download: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK7174415196693892096',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=9195',
                kind: 'inter_mdfcld0201',
                noKindFrom: 1,
            },
        };

        return (
            <React.Fragment>
                <div className={styles.main_content} style={style} ref={this.mainContent}>
                    <ArticleContent
                        content={content}
                        imagesInContent={imagesInContent}
                        pluginData={pluginData}
                        isBig={isBig}
                        pageType={pageType}
                        pageInfo={pageInfo}
                        textListAd={textListAd}
                        isHitBlack={isHitBlack}
                    />
                    {hasCopyRight && (
                        <div className={styles.copyRight}>
                            <p className={styles.copyRightCh}>
                                “特别声明：以上作品内容(包括在内的视频、图片或音频)为凤凰网旗下自媒体平台“大风号”用户上传并发布，本平台仅提供信息存储空间服务。
                            </p>
                            <p className={styles.copyRightZh}>
                                Notice: The content above (including the videos, pictures and audios if any) is uploaded
                                and posted by the user of Dafeng Hao, which is a social media platform and merely
                                provides information storage space services.”
                            </p>
                        </div>
                    )}
                    {maskShow ? (
                        <Chip
                            id="170111"
                            type="struct"
                            title="点击查看更多展现形式"
                            groupName="点击查看更多展现形式"
                            translate="handleUnfoldTypeData">
                            <div className={styles.more}>
                                <div className={styles.mask} />
                            </div>
                        </Chip>
                    ) : (
                        ''
                    )}
                </div>
                <div>
                    <SimpleGuideLayer
                        isShowGuideLayer={isShowGuideLayer}
                        unfoldType={unfoldType}
                        unfoldTextInfo={articleUnfoldLayer}
                        closeGuideFn={this.closeGuideLayer}
                        gotoClientFn={this.gotoClientLayer}
                    />
                </div>
                {maskShow ? (
                    <div className={styles.tip} onClick={this.getMore}>
                        <span>点击展开全文</span>
                        <span className={styles.arrow} />
                    </div>
                ) : (
                    ''
                )}
            </React.Fragment>
        );
    }
}

export default errorBoundary(MainContent);
